import tw, { styled } from 'twin.macro';
import { Wrapper, Headline } from '@/components/CarouselSection/CarouselSection.styles';
import CarouselSection from '@/components/CarouselSection/CarouselSection';

export const StyledCarouselSection = styled(CarouselSection)<{ hasSideContent: boolean }>`
  ${({ hasSideContent }) => (hasSideContent ? tw`col-span-12` : tw`col-span-10 col-start-2`)}
  &,
  ${Wrapper} {
    ${tw`w-full`}
    ${tw`bg-transparent`}
    ${tw`py-0!`}
    ${tw`my-[4px]`}
  }

  ${Headline} {
    ${tw`hidden`}
  }
`;
